import axios from "axios";
import merge from "lodash/merge";
import { useContext, useMemo } from "react";
import { configStore } from "../contexts/ConfigContext";
import { sessionStore } from "../contexts/SessionContext";
import { Application, ApplicationsConfig, Config } from "../interfaces/Config";
import { applyThemeWithLegacy } from "../utils/theme/theme-handler";

const useSelectApp = () => {
    const { config, setConfig } = useContext(configStore);
    const { setSession } = useContext(sessionStore);

    const selectApp = useMemo(
        () =>
            async (
                app: Application,
                applicationsConfig?: ApplicationsConfig
            ) => {
                const appOverrides: Partial<Config> = {
                    client_name: app.client_name,
                    lang: app.lang,
                    declinaison: app.app,
                };
                let newMinimalconfig = {};
                if (
                    config &&
                    (app.globalConfig || applicationsConfig?.globalConfig)
                ) {
                    const { data: minimalConfig } = await axios.get(
                        `${config.apiUrls.endpoints.assetsProxy}${
                            app.globalConfig || applicationsConfig?.globalConfig
                        }`
                    );
                    newMinimalconfig = minimalConfig.config;
                    applyThemeWithLegacy(minimalConfig.theme);
                }
                setConfig((config) =>
                    merge(
                        {},
                        config,
                        newMinimalconfig,
                        applicationsConfig ?? {},
                        appOverrides
                    )
                );
                setSession((session) => ({
                    ...session,
                    app: app.app,
                }));
            },
        [config, setConfig, setSession]
    );

    return selectApp;
};

export default useSelectApp;
